import _taggedTemplateLiteral from "/codebuild/output/src748241224/src/github.com/EverlyWell/www/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n"]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n"]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  ", " {\n    margin-top: ", "px;\n    font-size: 1rem;\n    line-height: 1.75;\n  }\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  /* \n    Hacky as hell. We probably need a better way to\n    set the star/font size simultaneously\n  */\n  ", " {\n    svg {\n      width: 13px;\n      height: 13px;\n    }\n    & > div > div:last-of-type {\n      font-size: ", "px;\n    }\n  }\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 45px;\n  height: 45px;\n  border-radius: 50%;\n  background-color: ", ";\n  position: absolute;\n  top: ", "px;\n  right: ", "px;\n\n  ", " {\n    top: ", "px;\n    right: ", "px;\n  }\n  ", " {\n    top: 12.5%;\n    right: 12.5%;\n  }\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 2.5rem;\n  width: 100%;\n  bottom: 0;\n  background-color: rgba(255, 255, 255, 0.6);\n  color: ", ";\n  font-size: 0.875rem;\n  font-weight: ", ";\n\n  ", " {\n    font-size: 1.125rem;\n  }\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  margin-bottom: ", "px;\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n  font-weight: ", ";\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n  margin-top: ", "px;\n  margin-left: ", "px;\n  ", " {\n    ", ";\n    color: ", ";\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n  margin-top: ", "px;\n  text-decoration: ", ";\n  ", " {\n    ", ";\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex: 1 0 100%;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  ", "\n\n  ", " {\n    ", "\n    color: ", ";\n    margin-bottom: ", "px;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  bottom: ", "px;\n  right: ", "px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  padding: ", "px;\n  text-decoration: none;\n  ", " {\n    padding: ", "px;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  align-items: center;\n  overflow: hidden;\n  position: relative;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border: solid 1px ", ";\n  border-radius: ", "px;\n  box-shadow: 0 7px 30px -10px #dce4e5;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  text-decoration: none;\n  &:hover {\n    cursor: pointer;\n  }\n\n  ", " {\n    border-radius: ", "px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from "styled-components";
import { animated as A } from "react-spring";
import { colors, typography, size, mediaQueries } from "../../../shared/constants";
import StarReviews from "../../StarReviews";
var Product = styled.a(_templateObject(), colors.white, colors.teal1, size.xs3, mediaQueries.forTabletVerticalUp, size.xs2),
    ImageWrapper = styled.div(_templateObject2()),
    ContentWrapper = styled.div(_templateObject3(), size.xs1, mediaQueries.forTabletVerticalUp, size.md),
    CartControlWrapper = styled.div(_templateObject4(), size.xs1, size.xs2),
    ProductName = styled.p(_templateObject5(), typography.buttonTextSmall, mediaQueries.forTabletHorizontalUp, typography.buttonText, colors.green5, size.xs1),
    PriceContainer = styled.div(_templateObject6()),
    ProductPrice = styled.p(_templateObject7(), typography.bodyTextSmall, colors.gray5, size.xs2, function (e) {
  return e.hasPromoPrice ? "line-through" : null;
}, mediaQueries.forTabletHorizontalUp, typography.subtitle),
    PromoPrice = styled.p(_templateObject8(), typography.bodyTextSmall, colors.red3, size.xs2, size.sm, mediaQueries.forTabletHorizontalUp, typography.subtitle, colors.red3),
    PromoText = styled.p(_templateObject9(), typography.bodyTextSmall, colors.red3, typography.weight.bold),
    Copy = styled.p(_templateObject10(), typography.captionText, size.lg);
export var OutOfStock = styled.div(_templateObject11(), colors.gray4, typography.weight.bold, mediaQueries.forTabletHorizontalUp);
export var SaleIcon = styled.div(_templateObject12(), typography.buttonTextSmall, colors.white, colors.red3, size.sm, size.sm, mediaQueries.forTabletVerticalUp, size.md, size.md, mediaQueries.forTabletHorizontalUp);
export var Reviews = styled(StarReviews)(_templateObject13(), mediaQueries.forPhoneOnly, size.sm);
export var Description = styled.p(_templateObject14(), typography.captionText, mediaQueries.forTabletHorizontalUp, size.sm);
export var AnimatedProductImage = styled(A.img)(_templateObject15());
export var AnimatedProductImageComponent = styled(A.div)(_templateObject16());
export { Product, ImageWrapper, ProductName, PriceContainer, ProductPrice, PromoPrice, PromoText, ContentWrapper, CartControlWrapper, Copy };